/**
 * Create by Alex
 * Description:
 *
 * ------ maintenance history ------
 * 2025/4/21 added to support impacted entry template
 */

import { businessConstants } from '../constants/business.constants';

export class ImpactedEntryTemplateConfig {
    name: string;
    type: string;
    setting: string;

    /**
     * Parse the impacted entry template config from response
     * @param serverResponse
     * @returns A array of impacted entry templates
     */
    static parse(serverResponse): Array<ImpactedEntryTemplateConfig> {
        const serverRes = serverResponse['entry-type-list'];
        if (!serverRes) {
            return null;
        }
        const impactedEntryTemplateConfig: Array<ImpactedEntryTemplateConfig> = new Array<ImpactedEntryTemplateConfig>();

        if (serverRes && serverRes.length > 0) {
            serverRes.forEach(item => {
                impactedEntryTemplateConfig.push(
                    {
                        name: item.name,
                        type: businessConstants.impactedConfigType.entryTemplate,
                        setting: item.AdhocFields
                    }
                );
            });
        }
        return impactedEntryTemplateConfig;
    }
}
